import Configuration from "../Config/Config";
import { createClient } from "urql";

const graphQLClient = new createClient({ url: Configuration.urlGraphQl });

export default graphQLClient;
